import { useLocation, useNavigate } from 'react-router-dom';
import Navbar from './Navbar';
import { useContext, useState } from 'react';
import UserProfile from './UserProfile';
import BillingPage from './BillingPage';
import { UserContext } from '../Context/UserContext';
import FeedbackPopup from '../Common/FeedbackPopup';
import FooterComponent from '../Common/FooterComponent';
import { sentryLog } from '../Utils/SentryLog';
import { getLqzyParams } from '../Utils/GetLqzyParams';

const lemonSqzyQueryParams = getLqzyParams();

function UserAccount({isIndianUser}){

    const [category, setCategory] = useState("profile");
    const [showFeedbackPopup, setShowFeedbackPopup] = useState(false);

    const { user } = useContext(UserContext);

    const isShowConsole = process.env.NODE_ENV === 'development';

    const location = useLocation();
    const navigate = useNavigate();

    isShowConsole && console.log('user account user check ssrk: ', user);
    isShowConsole && console.log("Current Path:", location.pathname); 

    const API_BASE_URL = process.env.NODE_ENV === 'development' ? process.env.REACT_APP_LOCAL_API_URL : process.env.REACT_APP_API_URL;

    const initiateLogout = e => {
        try{
            window.location.href = `${API_BASE_URL}/auth/logout`;
        }catch(err){
            isShowConsole && console.error('error in initiate logout method: ', err);
            sentryLog(`UserAccount.js - initiateLogout failed: ${err?.message || err} | user: ${JSON.stringify(user)}`);
        }
    }

    const handleHelp = e => {
        try{
            navigate(`/contact-us${lemonSqzyQueryParams}`);
        }catch(err){
            isShowConsole && console.error('error in handle help method: ', err);
            sentryLog(`UserAccount.js - handleHelp failed: ${err?.message || err} | user: ${JSON.stringify(user)}`);
        }
    }

    const openSheetsExtensionAccountInfoPage = e => {
        try{
            window.open(
                'https://www.easyimagetotext.com/sheets-extension-user-account',
                "_blank"
            );
        }catch(err){
            isShowConsole && console.error('error in openSheetsExtensionAccountInfoPage method: ', err);
            sentryLog(`PricingPage.js - openSheetsExtensionAccountInfoPage failed: ${err?.message || err} | user: ${JSON.stringify(user)}`);
        }
    }
    
    return(
        <div className='parentDiv'>
            <div className='mainDiv userAccount'>
                <div className='header'>
                    <Navbar />
                </div>
                <div className='contentDiv'>
                    <div className='containerDiv'>
                        <div className='title'>Account Information</div>
                        <div className='contentBox'>
                            <div className='content'>
                                <div className='lhs'>
                                    <div className='container'>
                                        <div className='top-section'>
                                            <div className={`category ${category === 'profile' ? 'selected' : ''}`} onClick={() => setCategory("profile")}>Profile Details</div>
                                            <div className={`category ${category === 'billing' ? 'selected' : ''}`} onClick={() => setCategory("billing")}>Billing Details</div>
                                        </div>
                                        <div className='bottom-section'>
                                            <div className='category' onClick={handleHelp}>Need Help ?</div>
                                            <div className='category' onClick={initiateLogout}>Logout</div>
                                        </div>
                                    </div>
                                </div>
                                {user && <div className='rhs'>
                                    {category === 'profile' ? <UserProfile userDetails={user}/> : category === "billing" ? <BillingPage isIndianUser={isIndianUser} userDetails={user}/> : ""}
                                </div>}
                                <div className='mobileBottomSection'>
                                    <div className='container'>
                                        <div className='category' onClick={handleHelp}>Need Help ?</div>
                                        <div className='category' onClick={initiateLogout}>Logout</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {showFeedbackPopup && <FeedbackPopup closeFeedbackPopup={() => setShowFeedbackPopup(false)}/>}
            </div>
            <FooterComponent setShowFeedbackPopup={setShowFeedbackPopup}/>
        </div>
    )
}

export default UserAccount;